import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { SocketService } from 'src/app/services/socket.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-accounts-charts',
  templateUrl: './accounts-charts.component.html',
  styleUrls: ['./accounts-charts.component.css']
})
export class AccountsChartsComponent implements OnInit {

  chartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#000000' : '#ffffff';
  piechartColor = (localStorage.getItem("Sastana-Theme") == 'darktheme') ? '#2740a6' : '#2740a6';
  accounts: any[];
  chartDatas: any;
  element: any;
  usersCount: any;
  accounts1: any[];
  accounts2: any[];
  accounts3: any[];
  priceValue: any[];
  priceDatas: any;
  usersBalance: any;
  chartName: any;
  address: string;
  chartOptions: Highcharts.Options = {};


  constructor(private conn: ConnectionService, private router: Router,
    private alert: ToastrService, private activatedRoute: ActivatedRoute, private socketService: SocketService,private spinner : NgxSpinnerService) {
    this.conn.themes.subscribe(resData => {
      setTimeout(() => {
        if (resData) {
          this.chartColor = (resData == 'darktheme') ? '#000000' : '#ffffff';
          this.piechartColor = (resData == 'darktheme') ? '#2740a6' : '#ffffff';
        }
      }, 4000);
    });
  }

  ngOnInit() {
    this.chartName = this.activatedRoute.snapshot.params['name'];
    this.yearlyAccounts('yearly');
    this.monthlyAccounts('monthly');
    this.dailyAccounts('daily');
    this.sastPrice()
  }

  yearlyAccounts(charttype: any) {
    // this.spinner.show()
    this.accounts = []
    this.conn.postUrl('users/account-growth', { type: charttype }).subscribe((chartres: any) => {
      // this.spinner.hide()

      this.chartDatas = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.chartDatas.length; index++) {
        this.element = this.chartDatas[index];
        this.usersCount = this.element.usersCount
        this.accounts.push(this.usersCount)
        categoriesData.push(this.chartDatas[index].year)
        this.yearlyChart(categoriesData);
      }
    })
  }

  monthlyAccounts(charttype: any) {
    this.accounts1 = []
    this.conn.postUrl('users/account-growth', { type: charttype }).subscribe((chartres: any) => {
      this.chartDatas = chartres.data
      let categoriesData1 = []
      for (let index = 0; index < this.chartDatas.length; index++) {
        this.element = this.chartDatas[index];
        this.usersCount = this.element.usersCount
        this.accounts1.push(this.usersCount)
        categoriesData1.push(this.chartDatas[index].monthInName)
        this.monthlyChart(categoriesData1);

      }
    })
  }

  dailyAccounts(charttype: any) {
    this.accounts2 = []
    this.conn.postUrl('users/account-growth', { type: charttype }).subscribe((chartres: any) => {
      this.chartDatas = chartres.data
      let categoriesData2 = []
      for (let index = 0; index < this.chartDatas.length; index++) {
        this.element = this.chartDatas[index];
        this.usersCount = this.element.usersCount
        this.accounts2.push(this.usersCount)
        categoriesData2.push(this.chartDatas[index].date)
        this.dailyChart(categoriesData2);

      }
    })
  }

  yearlyChart(category: any) {
    Highcharts.chart('yearly_account_growth', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y}</b></span>`,
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Active Accounts',
        color: '#2740a6',
        data: this.accounts,
      }],
    } as any);
  }

  monthlyChart(category: any) {
    Highcharts.chart('monthly_account_growth', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y}</b></span>`,
       
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Active Accounts',
        color: '#2740a6',
        data: this.accounts1,
      }],
    } as any);
  }

  dailyChart(category: any) {
    Highcharts.chart('daily_account_growth', {
      chart: {
        backgroundColor: this.chartColor,
        type: 'line',
      },
      title: {
        text: '',
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      yAxis: {
        title: {
          text: null,
        }
      },
      xAxis: {
        categories: category,
      },
      tooltip: {
        pointFormat: `<span style="color:{series.color};padding:0">{series.name}: </span><span style="padding:0"><b>{point.y} </b></span>`,
        
        style :{
          backgroundColor:'#ffffff'
        }
      },
      series: [{
        name: 'Active Accounts',
        color: '#2740a6',
        data: this.accounts2,
      }],
    } as any);
  }

  sastPrice() {
    this.priceValue = []
    this.conn.postUrl('users/priceChart', {}).subscribe((chartres: any) => {
      this.priceDatas = chartres.data
      let categoriesData = []
      for (let index = 0; index < this.priceDatas.length; index++) {
        this.element = this.priceDatas[index];
        this.usersBalance = this.element.balance
        this.priceValue.push(this.usersBalance)
        this.address = this.priceDatas[index].address.slice(0,3)+ '..' + this.priceDatas[index].address.slice(30,34)
        categoriesData.push(this.address)
        this.sastHolders(categoriesData);
      }
    })
  }

  sastHolders(category: any) {
    Highcharts.chart('sast_holders', {
      chart: {
        type: 'area'
      },
      accessibility: {
        description: '',
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      xAxis: {
        categories: category
      },
      yAxis: {
        title: {
          text: ''
        },
      },
      tooltip: {
        pointFormat: '{series.name} <b>{point.y}</b>'
      },
      plotOptions: {
        series: {
          states: {
            inactive: {
              opacity: 1
            }
          }
        }
        // area: {
        //   marker: {
        //     enabled: false,
        //     symbol: 'circle',
        //     radius: 2,
        //     states: {
        //       hover: {
        //         enabled: true
        //       }
        //     }
        //   }
        // }
      },
      series: [{
        name: 'SAST Holders',
        color: '#2740a6',
        data: this.priceValue
      }],
    } as any);
  }
}
